import React, { useEffect } from 'react';
import { useAuth } from '../../hooks/useAuth';
import { useFollow, useFollowStatus } from '../../hooks/useFollow';
import { theme } from '../../config/theme';

const FollowButton = ({ sellerId, size = 'md' }) => {
  const { isAuthenticated, isCustomer } = useAuth();
  const { actionLoading, checkFollowStatus, toggleFollow } = useFollow();
  const isFollowing = useFollowStatus(sellerId);

  useEffect(() => {
    if (isAuthenticated && isCustomer && sellerId) {
      checkFollowStatus(sellerId);
    }
  }, [sellerId, isAuthenticated, isCustomer, checkFollowStatus]);

  // Don't render for non-customers
  if (!isAuthenticated || !isCustomer) return null;

  // Show skeleton while status is unknown (null = not yet fetched)
  if (isFollowing === null) {
    return <div style={skeletonStyles(size)} />;
  }

  const handleClick = (e) => {
    e.stopPropagation();
    toggleFollow(sellerId, isFollowing);
  };

  return (
    <button
      onClick={handleClick}
      disabled={actionLoading}
      style={btnStyles(isFollowing, size, actionLoading)}
      onMouseEnter={(e) => {
        if (!actionLoading) {
          e.currentTarget.style.opacity = '0.85';
          if (isFollowing) {
            e.currentTarget.textContent = 'Unfollow';
          }
        }
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.opacity = '1';
        e.currentTarget.textContent = isFollowing ? 'Following' : 'Follow';
      }}
    >
      {isFollowing ? 'Following' : 'Follow'}
    </button>
  );
};

const btnStyles = (isFollowing, size, disabled) => ({
  padding: size === 'sm'
    ? `${theme.spacing.xs} ${theme.spacing.md}`
    : `${theme.spacing.sm} ${theme.spacing.lg}`,
  fontSize: size === 'sm'
    ? theme.typography.fontSize.xs
    : theme.typography.fontSize.sm,
  fontWeight: theme.typography.fontWeight.medium,
  borderRadius: theme.borderRadius.full,
  border: `1px solid ${isFollowing ? theme.colors.gray[300] : theme.colors.primary.main}`,
  backgroundColor: isFollowing ? theme.colors.white : theme.colors.primary.main,
  color: isFollowing ? theme.colors.text.primary : theme.colors.white,
  cursor: disabled ? 'not-allowed' : 'pointer',
  opacity: disabled ? 0.7 : 1,
  transition: theme.transitions.base,
  minWidth: '80px',
});

const skeletonStyles = (size) => ({
  width: '80px',
  height: size === 'sm' ? '24px' : '32px',
  borderRadius: theme.borderRadius.full,
  backgroundColor: theme.colors.gray[200],
  animation: 'pulse 1.5s ease-in-out infinite',
});

export default FollowButton;